import { render, staticRenderFns } from "./BloodPressure.vue?vue&type=template&id=1a90bd5e&scoped=true&"
import script from "./BloodPressure.vue?vue&type=script&lang=js&"
export * from "./BloodPressure.vue?vue&type=script&lang=js&"
import style0 from "./BloodPressure.vue?vue&type=style&index=0&id=1a90bd5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a90bd5e",
  null
  
)

export default component.exports